import React from 'react';
import './logo.css';
import babelogo from "../../images/Babe-logo.svg"

const Logo = () => {
    return (
      <div className="logo-container">
        <img src={babelogo} alt="Babe logo" style={{ width: '300px', height: 'auto' }}/>
      </div>
    );
  };

export default Logo;